import { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Building2, Boxes, KeyRound, LayoutDashboard, ScrollText, Users } from 'lucide-react'
import { AuthContext, isPlatformUser } from '@retink/web-auth'
import type { Crumb, NavEntry } from '@retink/web-ui'
import { signOut } from '../lib/api'
import { ConsoleShell } from './ConsoleShell'

export function ConsoleFrame() {
  const { user } = useContext(AuthContext)
  const { pathname } = useLocation()
  const platform = isPlatformUser(user)
  if (!platform && user?.orgRole !== 'admin') return <Navigate to="/" replace />

  const routeOrgId = pathname.match(/^\/organizations\/([^/]+)/)?.[1]
  const orgId = routeOrgId ?? (!platform ? user?.orgId : undefined)
  const nav: NavEntry[] = orgId ? organizationNav(orgId) : platformNav
  const breadcrumb: Crumb[] | undefined = routeOrgId && platform
    ? [{ label: 'Organizations', to: '/organizations' }, { label: 'Organization' }]
    : undefined

  return (
    <ConsoleShell
      nav={nav}
      onSignOut={signOut}
      navGroup={{ label: orgId ? 'Organization' : 'Platform' }}
      breadcrumb={breadcrumb}
      roleLabel={!platform ? 'org admin' : undefined}
      accountPath="/account"
    />
  )
}

const platformNav: NavEntry[] = [
  { to: '/organizations', icon: Building2, label: 'Organizations' },
  { to: '/staff', icon: Users, label: 'Staff' },
  { heading: 'Operations' },
  { to: '/operations/services', icon: Boxes, label: 'Services' },
  { to: '/operations/audit', icon: ScrollText, label: 'Activity' },
  { to: '/operations/identity-providers', icon: KeyRound, label: 'Identity providers' },
  { to: '/operations/identities', icon: Users, label: 'All identities' },
]

function organizationNav(orgId: string): NavEntry[] {
  const base = `/organizations/${orgId}`
  return [
    { to: `${base}/overview`, icon: LayoutDashboard, label: 'Overview' },
    { to: `${base}/people`, icon: Users, label: 'People' },
    { to: `${base}/identity`, icon: KeyRound, label: 'Identity' },
    { to: `${base}/workspaces`, icon: Boxes, label: 'Workspaces' },
    { to: `${base}/activity`, icon: ScrollText, label: 'Activity' },
  ]
}
